import { Value } from '@philips-internal/oswald-ui-core';

interface PendingApprovalRequest {
  step: string,
  approvalSequence: number | string,
  approvalProcessSequence: number | string
}

interface PendingApprovalSecondStepRequest {
  step: string,
  approvalSequence: number | string,
  approvalProcessSequence: number | string,
  purchaseOrder: string,
  documentNumber: number,
  purchaseRequestNumber: number
}

interface PendingApprovalThirdStepRequest {
  step: string,
  approvalSequence: number | string,
  approvalProcessSequence: number | string,
  documentNumber: number,
  purchaseRequestNumber: number
}

interface PendingApprovalFourthStepRequest {
  step: string,
  documentNumber: number,
  purchaseRequestNumber: number,
  approvalSequence: number | string,
  approvalProcessSequence: number | string,
  purchaseOrder: string,
}

type ApprovalOrderItemResponse = {
  noticeDescription: string,
  questionDescription: string,
  ruleSequence: number,
  forwardProcessLimitApproval: boolean,
  type: string,
  approvalCeiling: boolean,
  includeBalance: boolean,
  abortMessage: string,
  numberRecords: number,
  numberIntegratedItems: number,
  responseStatusSending: string,
  purchaseQuotationNumber: number,
  externalDocumentNumber: string,
  typeInterfaceIntegration: string,
  pathSendingDescription: string,
  integratePurchaseRequest: boolean,
  sendOnlyFewItemsToIntegration: boolean,
  approvalDate: Date,
  email: string,
  contact: string,
  ccEmail: string,
  documentApproved: boolean
};

interface FormData extends PendingApprovalRequest, Record<string, Value> {}
interface FormDataSecondStep extends PendingApprovalSecondStepRequest, Record<string, Value> {}
interface FormDataThirdStep extends PendingApprovalThirdStepRequest, Record<string, Value> {}
interface FormDataFourthStep extends PendingApprovalFourthStepRequest, Record<string, Value> {}

const normalizeApprovalProcessBody = (step: string, approvalSequence: number | string, approvalProcessSequence: number | string): FormData => ({
  step: step,
  approvalSequence: approvalSequence,
  approvalProcessSequence: approvalProcessSequence,
});

const normalizeApprovalProcessSecondStepBody = (step: string, approvalSequence: number | string, approvalProcessSequence: number | string, purchaseOrder: string, documentNumber: number, purchaseRequestNumber: number): FormDataSecondStep => ({
  step: step,
  approvalSequence: approvalSequence,
  approvalProcessSequence: approvalProcessSequence,
  purchaseOrder,
  documentNumber,
  purchaseRequestNumber,
});

const normalizeApprovalProcessThirdStepBody = (step: string, approvalSequence: number | string,  approvalProcessSequence: number | string, documentNumber: number, purchaseRequestNumber: number): FormDataThirdStep => ({
  step: step,
  approvalSequence: approvalSequence,
  approvalProcessSequence: approvalProcessSequence,
  documentNumber,
  purchaseRequestNumber,
});

const normalizeApprovalProcessFourthStepBody = (step: string, approvalSequence: number | string, approvalProcessSequence: number | string, documentNumber: number, purchaseRequestNumber: number, purchaseOrder: string): FormDataFourthStep => ({
  step,
  approvalSequence,
  approvalProcessSequence: approvalProcessSequence,
  documentNumber,
  purchaseRequestNumber,
  purchaseOrder,
});
  
export {
  normalizeApprovalProcessBody,
  normalizeApprovalProcessSecondStepBody,
  normalizeApprovalProcessThirdStepBody,
  normalizeApprovalProcessFourthStepBody,
  ApprovalOrderItemResponse,
};
